module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-info"
  }, [_c('div', {
    staticClass: "lesson-price"
  }, [(_vm.priceType === 'CASH_POINT') ? _c('div', {
    staticClass: "cash-point"
  }, [_c('div', {
    staticClass: "point-price"
  }, [_c('div', {
    staticClass: "price-tag"
  }, [_vm._v("积分价")]), _vm._v(" "), _c('div', {
    staticClass: "real-price"
  }, [(_vm.spvPoint.item.price.pointPrice > 0) ? _c('span', [_c('price', {
    attrs: {
      "data": _vm.spvPoint.item.price.pointPrice
    }
  }), _vm._v(" + ")], 1) : _vm._e(), _vm._v(_vm._s(_vm.spvPoint.item.price.point) + " "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("积分" + _vm._s(_vm.spvPoint.single ? '' : '起'))])]), _vm._v(" "), _c('div', {
    staticClass: "raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvPoint.item.price.rawPrice
    }
  }), _vm._v(_vm._s(_vm.spvPoint.single ? '' : '起'))], 1)]), _vm._v(" "), (_vm.product.allowOnlyCash) ? _c('div', {
    staticClass: "cash-price"
  }, [_c('div', {
    staticClass: "price-tag"
  }, [_vm._v("现金价")]), _vm._v(" "), _c('div', {
    staticClass: "real-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvCash.item.price.price
    }
  }), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.spvCash.single ? '' : '起'))])], 1), _vm._v(" "), (_vm.spvCash.item.price.rawPrice != _vm.spvCash.item.price.price) ? _c('div', {
    staticClass: "raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvCash.item.price.rawPrice
    }
  }), _vm._v(_vm._s(_vm.spvCash.single ? '' : '起'))], 1) : _vm._e()]) : _vm._e()]) : (_vm.priceType === 'CASH_ONLY' && _vm.product.allowOnlyCash) ? _c('div', {
    staticClass: "cash-only"
  }, [_c('div', {
    staticClass: "cash-price"
  }, [_c('div', {
    staticClass: "real-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvCash.item.price.price
    }
  }), _c('span', {
    staticClass: "unit"
  }, [_vm._v(" " + _vm._s(_vm.spvCash.single ? '' : '起'))])], 1), _vm._v(" "), (_vm.spvCash.item.price.rawPrice != _vm.spvCash.item.price.price) ? _c('div', {
    staticClass: "raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvCash.item.price.rawPrice
    }
  }), _vm._v(_vm._s(_vm.spvCash.single ? '' : '起'))], 1) : _vm._e()])]) : (_vm.priceType === 'FREE') ? _c('div', {
    staticClass: "free"
  }, [_vm._v("免费报名")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lesson-class"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("场次信息")]), _vm._v(" "), _c('div', {
    staticClass: "class-item"
  }, [_c('span', [_vm._v("时间: ")]), _vm._v(_vm._s(_vm.classTime))]), _vm._v(" "), _c('div', {
    staticClass: "class-item"
  }, [_c('span', [_vm._v("地点: ")]), _vm._v(_vm._s(_vm.classCity))]), _vm._v(" "), (_vm.product.status === 'REGISTER') ? _c('div', {
    staticClass: "class-item"
  }, [_c('span', [_vm._v("报名截止时间: ")]), _vm._v(_vm._s(_vm.product.registerEndTime))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18180377"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/lesson/product-info.vue
// module id = 1046
// module chunks = 2